import { commonReducers } from '@americanexpress/banking-common';
import productsReducer from 'axp-product-ducks';
import { OneCache } from 'fetchye-one-app';
import { resourcesReducer } from 'iguazu-rest';
import { proceduresReducer } from 'iguazu-rpc';
import { combineReducers } from 'redux-immutable';

export default combineReducers({
  procedures: proceduresReducer,
  resources: resourcesReducer,
  products: productsReducer,
  fetchye: OneCache().reducer,
  ...commonReducers,
});
